export { default as StrategyProviderSearch } from './StrategyProviderSearch';
